import axios from "axios";
import React, { useState } from "react";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";
import LoadingSpinner from "../../../components/LoadingSpinner";
export default function DeleteImageModal({ id, cancelModal }) {
  const [deleteComplete, setDeleteComlete] = useState(false);
  const { user } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);
  //styled
  const handleDelete = async () => {
    setIsLoading(true);
    try {
      const imgDeleteResponse = await axios.delete(
        `${ApiConnectionString}/api/image/${id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (imgDeleteResponse.status === 200) {
        setDeleteComlete(true);
      }
    } catch (error) {
      console.error("Error deleting image:", error);
      // Optionally handle the error (e.g., show a message to the user)
    } finally {
      setIsLoading(false); // Ensure the loading state is reset
    }
  };

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
        </div>
      </div>
    );
  } else {
    if (deleteComplete) {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Image Deleted</p>
            </div>
            <button
              type="button"
              className="close-button"
              onClick={cancelModal}
              aria-label="Close"
            >
              &times;
            </button>
            <p>The image was successfully deleted.</p>

            <div className="send-modal-footer">
              <button
                onClick={cancelModal}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Delete card</p>
            </div>

            <button
              type="button"
              className="close-button"
              onClick={cancelModal}
              aria-label="Close"
            >
              &times;
            </button>
            <p>Are you sure you want to delete this image?</p>
            <img
              src={`${ApiConnectionString}/api/image/${id}`}
              alt="Club Image"
              width={200}
              className="img-fluid"
            />
            <div className="send-modal-footer">
              <button className="delete-button mx-3" onClick={handleDelete}>
                Confirm
              </button>
              <button
                onClick={cancelModal}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      );
    }
  }
}
